import React, {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useParams} from 'react-router-dom'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import CustomLabel from '../../../../../common/components/label/CustomLabel'
//import {useSelector} from 'react-redux'
import // getPointVigilance,
// getProjectByGuid,
// getProposal,
// getProposalMaterialList,
// getProposalSettings,
// getWorkSite,
// putProposalSubmit,
'../../core/_requests'
import Select from 'react-select'
// import {selectCustomStyle, selectDarkCustomStyle} from '../../../../../common/styles/selectCustom'
// import CustomTable from '../../../../../common/components/tables/CustomTable'
// import {parseProposalServicesDataToTable} from '../../../../../pages/project/helpers/proposalServicesParser'
import {Button, Modal} from 'react-bootstrap'
//import {toast} from 'react-toastify'
//import {useAuth} from '../../../../auth'
//import Tab5Table from './Tab5Table'

// import { Logout } from '../../../../auth'

type NPTab5FormProps = {
  screenType?: 'small' | 'large'
  tableData?: Array<{
    columns: Array<{
      colIndex: number
      value: any
      type: 'text' | 'date' | 'integer' | 'decimal' | 'percent'
      rowIndex: number
      dataKey: string
      rowGuid: string
      content?: any
    }>
    rowType: 'data' | 'header'
    rowIndex: number
    rowGuid: string
  }>
  onSort?: (crit: {Sort: string; Order: 'asc' | 'desc'}) => void
  activeSort?: {Sort: string; Order: 'asc' | 'desc'}
  proposal?: any
  materielOptions?: Array<any>
  settings?: any
  updateProposal?: () => void
  onSettingsChange?: (newSettings: any) => void
  onCommentChange?: (text: string) => void
  vigilent?: any
  updating?: boolean
  loading?: boolean
  selectedMateriel?: any
  onSelectMaterial?: (mat: any) => void
  children?: React.ReactNode,
  submitting?: boolean,
  setSubmitting?: (sub: boolean) => void
}

const NPTab5Form: FC<NPTab5FormProps> = ({
  screenType = 'large',
  tableData = [],
  activeSort,
  onSort,
  proposal = null,
  materielOptions = [],
  settings = null,
  updateProposal,
  onSettingsChange,
  onCommentChange,
  vigilent = null,
  updating = false,
  loading = false,
  selectedMateriel = null,
  onSelectMaterial,
  children,
  submitting,
  setSubmitting
}) => {
  // const {setAuthMessage, logout} = useAuth()
  const {pGuid} = useParams()
  const intl = useIntl()
  const { modeSelect} = useThemeMode()
  // const projectData = useSelector((state: any) => state?.projectData)
  // const [loading, setLoading] = useState<boolean>(true)
  // const [materielOptions, setMaterielOptions] = useState<Array<any>>([])
  // const [locationDate, setLocationDate] = useState<string>('')
  // const [selectedMateriel, setSelectedMateriel] = useState<any>(null)
  // const [proposal, setProposal] = useState<any>(null)
  const [, setShowbq] = useState<boolean>(false)
  // const [showCancel, setShowCancel] = useState<boolean>(false)
  const [, setW2go] = useState<'tab1' | 'tab2' | 'tab4' | 'tab3'>('tab1')
  const [isThereModif, ] = useState<boolean>(false)
  // const [ws, setWs] = useState<any>(null)
  // const [project, setProject] = useState<any>(null)
  // const [settings, setSettings] = useState<any>(null)
  // const [tableRows, setTableRows] = useState<Array<any>>([])
  //const [submitting, setSubmitting] = useState<boolean>(false)
  // const [vigilent, setVigilent] = useState<any>(null)
  // const [comments, setComments] = useState<string>('')
  // const [updating, setUpdateing] = useState<boolean>(false)

  const navigate = useNavigate()

  // const loadWorkSite = async () => {
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const wsObjRes = await getWorkSite(
  //     {Guid: ProjectGuid},
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     },
  //     ({Message, MessageType, Toast, ToastType}) => {
  //       if (Message && MessageType === 'Success') {
  //         //
  //       } else if (Message && MessageType === 'Error') {
  //         //
  //       } else if (Toast && ToastType === 'Success') {
  //         toast(Toast, {type: 'success'})
  //       } else if (Toast && ToastType === 'Error') {
  //         toast(Toast, {type: 'error'})
  //       }
  //     }
  //   )
  //   if (wsObjRes?.data?.data) {
  //     setWs(wsObjRes?.data?.data)
  //   }
  // }

  // const loadProject = async () => {
  //   const projectRes = await getProjectByGuid(
  //     {Guid: pGuid || projectData?.tab1?.data?.Guid || ''},
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     },
  //     ({Message, MessageType, Toast, ToastType}) => {
  //       if (Message && MessageType === 'Success') {
  //         //
  //       } else if (Message && MessageType === 'Error') {
  //         //
  //       } else if (Toast && ToastType === 'Success') {
  //         toast(Toast, {type: 'success'})
  //       } else if (Toast && ToastType === 'Error') {
  //         toast(Toast, {type: 'error'})
  //       }
  //     }
  //   )
  //   if (projectRes && projectRes?.data?.data) {
  //     setProject(projectRes?.data?.data)
  //   }
  // }

  // const loadListMateriel = async () => {
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const listMatRes = await getProposalMaterialList(ProjectGuid, (message: string) => {
  //     setAuthMessage(message)
  //     logout()
  //   })
  //   if (listMatRes && listMatRes.data.data) {
  //     const opts = listMatRes.data.data?.map((op: any, ik: number) => {
  //       return {
  //         ...op,
  //         value: op?.Guid,
  //         label: op?.Name,
  //       }
  //     })

  //     if (opts && opts?.length > 0) {
  //       await setMaterielOptions(opts)
  //       setSelectedMateriel(opts[0])
  //     }
  //   }
  //   setLoading(false)
  // }

  // const loadVigilancePoint = async () => {
  //   const vigilance = await getPointVigilance()
  //   if (vigilance?.data?.data) {
  //     setVigilent(vigilance?.data?.data)
  //   }
  // }

  // const loadProposalSettings = async () => {
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const settRes = await getProposalSettings(
  //     {
  //       ProjectGuid: ProjectGuid || '',
  //       MaterialGuid: selectedMateriel?.Guid || '',
  //     },
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     }
  //   )
  //   if (settRes?.data?.data) {
  //     setSettings(settRes?.data?.data)
  //     console.log('settRes : ', settRes)
  //   }
  //   // setLoading(false)
  // }

  // const loadProposal = async () => {
  //   setProposal(null)
  //   setLoading(true)
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const proposalData = await getProposal(
  //     {
  //       ProjectGuid: ProjectGuid,
  //       MaterialGuid: selectedMateriel?.Guid || '',
  //     },
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     }
  //   )
  //   if (proposalData && proposalData?.data?.data) {
  //     setProposal(proposalData?.data?.data)
  //     // const dataStructed: Array<any> = parseProposalServicesDataToTable(proposalData?.data?.data?.Services || [])
  //     // let tableData: Array<any> = [];
  //     // tableData = proposalData?.data?.data?.Services
  //     //   ? [tHeader, ...dataStructed]
  //     //   : []
  //     setTableRows([...proposalData?.data?.data?.Services])
  //   }
  //   setLoading(false)
  // }

  // const updateProposal = async () => {
  //   setUpdateing(true)
  //   console.log('projectData?.tab1?.data : ', projectData?.tab1?.data || project)
  //   const ProjectGuid = pGuid || projectData?.tab1?.data?.Guid
  //   const mandates: any[] = []
  //   settings?.Mandatory?.forEach((mand: any) => {
  //     if (mand?.Selected === true) {
  //       mandates.push(mand?.Guid)
  //     }
  //     // return mand?.Guid
  //   })
  //   const otionals: any[] = []
  //   settings?.Optional?.forEach((mand: any) => {
  //     if (mand?.Selected === true) {
  //       otionals.push(mand?.Guid)
  //     }
  //     // return mand?.Guid
  //   })
  //   const data = {
  //     ProjectGuid: ProjectGuid,
  //     MaterialGuid: settings?.MaterialGuid,
  //     Mandatory: mandates,
  //     Optional: otionals,
  //     Comment: comments,
  //   }
  //   const res = await putProposalSubmit(
  //     data,
  //     (message: string) => {
  //       setAuthMessage(message)
  //       logout()
  //     },
  //     ({Message, MessageType, Toast, ToastType}) => {
  //       if (Message && MessageType === 'Success') {
  //         //
  //       } else if (Message && MessageType === 'Error') {
  //         //
  //       } else if (Toast && ToastType === 'Success') {
  //         toast(Toast, {type: 'success'})
  //       } else if (Toast && ToastType === 'Error') {
  //         toast(Toast, {type: 'error'})
  //       }
  //     }
  //   )
  //   setUpdateing(false)

  //   if (res.data?.Status?.Success) {
  //     setSubmitting(false)

  //   }
  //   await loadProposal()
  //   await loadProposalSettings()

  // }

  const handleMaterielChange = (selcted: any) => {
    // setSelectedMateriel(selcted)
    if (onSelectMaterial) {
      onSelectMaterial(selcted)
    }
  }

  const handleBackPress = () => {
    setW2go('tab4')
    if (isThereModif) {
      setShowbq(true)
    } else {
      navigate('/new-project/tab4' + (pGuid ? '/' + pGuid : ''), {replace: true})
    }
  }

  // useEffect(() => {
  //   const loadData = async () => {

  //   }
  //   loadData()
  // }, [])

  // useEffect(() => {
  //   const loadData = async () => {
  //     if (selectedMateriel) {
  //       await loadProposal()
  //       await loadProposalSettings()
  //     } else {
  //       await loadListMateriel()
  //       await loadVigilancePoint()
  //     }
  //   }
  //   loadData()
  // }, [selectedMateriel])

  // const tHeader: any = {
  //   columns: [
  //     {
  //       colIndex: 0,
  //       dataKey: 'VisuCode',
  //       rowGuid: 'Code_Visu',
  //       rowIndex: 0,
  //       type: 'text',
  //       value: 'VisuCode',
  //     },
  //     {
  //       colIndex: 1,
  //       dataKey: 'ServiceTitle',
  //       rowGuid: 'ServiceTitle',
  //       rowIndex: 0,
  //       type: 'text',
  //       value: 'ServiceTitle',
  //     },
  //     {
  //       colIndex: 2,
  //       dataKey: 'Quantity',
  //       rowGuid: 'Quantity',
  //       rowIndex: 0,
  //       type: 'text',
  //       value: 'Quantity',
  //     },
  //     {
  //       colIndex: 3,
  //       dataKey: 'UnitPrice',
  //       rowGuid: 'UnitPrice',
  //       rowIndex: 0,
  //       type: 'text',
  //       value: 'UnitPrice',
  //     },
  //     {
  //       colIndex: 3,
  //       dataKey: 'SubTotal',
  //       rowGuid: 'SubTotal',
  //       rowIndex: 0,
  //       type: 'text',
  //       value: 'SubTotal',
  //     },
  //   ],
  //   rowGuid: 'HeaderTC',
  //   rowIndex: 0,
  //   rowType: 'header',
  // }
  // const dataStructed: Array<any> = parseProposalServicesDataToTable(proposal?.Services || [])
  // let tableData: Array<any> = [];
  // const tableData = tableRows
  //   ? [tHeader, ...parseProposalServicesDataToTable(tableRows, {Sort: 'VisuCode', Order: 'asc'})]
  //   : []

  // console.log('tableData : ', tableData.length)

  // useEffect(() => {
  //   if (selectedMateriel) {
  //     loadProposal()
  //   }
  // }, [mode])

  // const TablesOf = () => {
  //   return <Tab5Table tableData={tableData} activeSort={activeSort} onSort={onSort} />
  // }

  return (
    <div
      className={'h-100 over-flow-hidden'}
      // style={{maxHeight: screenType === 'large' ? '65vh' : 'auto'}}
    >
      {(selectedMateriel || proposal?.LocationDuration) && (
        <div className='row'>
          <div className="col-md-6">
            {proposal?.LocationDuration && (
              <div className='row align-items-md-center mb-2 mb-md-0'>
                <div className='col-6 col-md-6 col-lg-3' style={{minWidth:'27%'}}>
                  <CustomLabel
                    text={intl.formatMessage({id: 'LOCATION_DATE'})}
                    className='mb-0 fw-bolder '
                    style={{color: '#57586C'}}
                  />
                </div>
                <div className='col-md-6 row align-items-center'>
                  <div className='col-11 col-md-8'>
                  <input
                    className='form-control form-control-solid text-right fs-4 fw-bolder '
                    value={proposal?.LocationDuration || ''}
                    style={{
                      textAlign: 'right',
                      backgroundColor: '#8F94A8',
                      color: 'white',
                    }}
                  />
                  </div>
                  <div className='col-1 col-md-3' style={{color: '#8F94A8'}}>
                     mois
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className='col-md-6'>
            {selectedMateriel && (
              <div className='row align-items-md-center'
              >
                <CustomLabel
                  text={'Materiel'}
                  className='mb-0 fw-bolder fs-7 col-md-4 col-lg-2'
                  style={{color: '#57586C'}}
                />
                <div className='col-md-8 col-lg-10'>
                  <Select
                  className='form-select-solid custom-select'
                  options={materielOptions}
                  onChange={handleMaterielChange}
                  value={selectedMateriel}
                  //styles={mode === 'light' ? selectCustomStyle : selectDarkCustomStyle}
                  styles={modeSelect}
                />
                </div>
              </div>
            )}
          </div>
        </div>
      )
      }
      {loading && (
        <div className='d-flex align-items-center justify-content-center'>
          <div className='spinner-border text-danger' role='status'>
            <span className='sr-only'>Chargement...</span>
          </div>
        </div>
      )}
      {!loading && proposal && tableData.length > 0 && (
        <div className={''}>
          {/* <Tab5Table tableData={tableData} activeSort={activeSort} onSort={onSort} /> */}
          {children}
        </div>
      )}
      {!loading && proposal && (
        <div className='row  align-items-center'>
          <div className='d-none d-md-block col-md-5'>
            <div
              className={''}
              style={{
                fontSize: 18,
                textTransform: 'uppercase',
                fontWeight: 'bold',
              }}
            >
              {intl.formatMessage({id: 'RESERVE_PRICE'})}
            </div>
          </div>
          <div className='col-md-7'>
            <div className='row align-items-center gap-lg-0  justify-content-md-end'>
              <div
                className='me-md-5 col-6 col-md-6 col-lg-5 text-start text-md-end'
                style={{
                  fontSize: 18,
                  textTransform: 'uppercase',
                  fontWeight: 'bold',
                }}
              >
                {intl.formatMessage({id: 'TOTAL_HT'})} :
              </div>
              <div className={'ms-md-5 col-6  col-md-6 col-lg-4 text-end'}>
                <Button
                  className={'btn-dark text-center'}
                  disabled
                  //style={{width: 120, textAlign: 'center'}}
                >
                  <div className='fw-bolder'>
                    {
                    /*  intl.formatNumber(proposal?.Total || 0, {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                    })*/
                        proposal?.Total || 0
                    }
                  </div>
                </Button>
              </div>
            </div>
          </div>
          <div className='d-md-none d-sm-block mt-5 mt-md-0 col-md-6'>
            <div
              className={''}
              style={{
                fontSize: 18,
                textTransform: 'uppercase',
                fontWeight: 'bold',
              }}
            >
              {intl.formatMessage({id: 'RESERVE_PRICE'})}
            </div>
          </div>
        </div>
      )}
      <div className={'d-flex justify-content-between align-items-center m-5 m-md-0'}>
        <div>
          <Button type='button' variant={'secondary'} onClick={handleBackPress}>
            <i className='ki-duotone ki-arrow-left fs-1'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
            {intl.formatMessage({id: 'PREVIOUS'})}
          </Button>
        </div>
        {(!loading && !selectedMateriel && !proposal?.LocationDuration) &&(<div className='d-flex flex-column align-items-center justify-content-center'>
            <span  className='fw-bolder fs-4 text-danger'>
              Vous devez sélectionner 1 matériel, à minima, dans l'onglet
            </span>
            <span  className='fw-bolder fs-4 text-danger'>
               "Conditions d'usages"pour avoir accès aux propositions.
            </span>
        </div>)}

        <div>
          {!loading && proposal && proposal.Submitted === false && (
            <Button
              className={'btn-primary'}
              onClick={() => {
                if(setSubmitting) {
                  setSubmitting(true)
                }
              }}
            >
              {intl.formatMessage({id: 'SUBMIT'})}
            </Button>
          )}
        </div>
      </div>
      <Modal show={submitting} size={'lg'}>
        <div className='p-5 '>
          {/* updateProposal */}
          <div className='w-100 rounded '>
            <div className='d-flex justify-content-between '>
              <div>
                {intl.formatMessage({id: 'PARAMS_SUBMIT_PRPOSAL'}) +
                  '"' +
                  settings?.MaterialCode +
                  '"'}
              </div>
              <div
                onClick={() => {
                  if(setSubmitting) {
                    setSubmitting(false)
                  }
                }}
              >
                <i className='fa-solid fa-xmark text-dark fs-2x '></i>
              </div>
            </div>
            <div>
              <div>
                <div className='fw-bolder text-dark d-flex align-items-center'>
                  <span>{'A la charge du client (obligatoires au devis)'}</span>
                  <span
                    style={{width: 24, height: 24, border: '2px solid #e74c3c', borderRadius: 100}}
                    className='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
                    onClick={(e) => {
                      window
                        ?.open(
                          'https://chastagner-dev.ms1.mentalworks.pro/Aide/Manuel.pdf#page=20&view=fit',
                          '_blank'
                        )
                        ?.focus()
                    }}
                  >
                    <i className='fa fa-question text-danger'></i>
                  </span>
                </div>
                <div className='mt-3'>
                  {settings?.Mandatory?.map((mande: any) => {
                    return (
                      <div
                        className={'d-flex p-3 '}
                        onClick={() => {
                          const mandates = [...settings?.Mandatory]
                          mandates?.forEach((e, i) => {
                            if (e?.Guid === mande?.Guid) {
                              mandates[i].Selected = !mandates[i].Selected
                            }
                          })
                          const newSetting = {
                            ...settings,
                            Mandatory: mandates,
                          }

                          // setSettings(newSetting)
                          if (onSettingsChange) {
                            onSettingsChange(newSetting)
                          }
                        }}
                      >
                        <input
                          className={' form-check-input fs-3 text-primary'}
                          type={'checkbox'}
                          checked={mande?.Selected}
                          style={{backgroundColor: '#9A9A9A', border: 0, outline: 'none'}}
                        />
                        <div className={'ms-3'}>{mande?.Name}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div>
                <div className='fw-bolder text-dark d-flex align-items-center '>
                  <span>{'A la charge du client (pour complément au devis)'}</span>
                  <span
                    style={{width: 24, height: 24, border: '2px solid #e74c3c', borderRadius: 100}}
                    className='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
                    onClick={(e) => {
                      window
                        ?.open(
                          'https://chastagner-dev.ms1.mentalworks.pro/Aide/Manuel.pdf#page=20&view=fit',
                          '_blank'
                        )
                        ?.focus()
                    }}
                  >
                    <i className='fa fa-question text-danger'></i>
                  </span>
                </div>
                <div className='mt-3'>
                  {settings?.Optional?.map((mande: any) => {
                    return (
                      <div
                        className={'d-flex p-3 '}
                        onClick={() => {
                          const mandates = [...settings?.Optional]
                          mandates?.forEach((e, i) => {
                            if (e?.Guid === mande?.Guid) {
                              mandates[i].Selected = !mandates[i].Selected
                            }
                          })
                          const newSetting = {
                            ...settings,
                            Optional: mandates,
                          }
                          // setSettings(newSetting)
                          if (onSettingsChange) {
                            onSettingsChange(newSetting)
                          }
                        }}
                      >
                        <input
                          className={' form-check-input fs-3 '}
                          type={'checkbox'}
                          checked={mande?.Selected}
                          style={{backgroundColor: '#9A9A9A', border: 0, outline: 'none'}}
                        />
                        <div className={'ms-3'}>{mande?.Name}</div>
                      </div>
                    )
                  })}
                </div>
                <div>
                  <div className='fw-bolder text-dark d-flex align-items-center'>
                    <span>{'Commentaire du commercial '}</span>
                    <span
                      style={{
                        width: 24,
                        height: 24,
                        border: '2px solid #e74c3c',
                        borderRadius: 100,
                      }}
                      className='mx-3 d-flex align-items-center justify-content-center cursor-pointer'
                      onClick={(e) => {
                        window
                          ?.open(
                            'https://chastagner-dev.ms1.mentalworks.pro/Aide/Manuel.pdf#page=20&view=fit',
                            '_blank'
                          )
                          ?.focus()
                      }}
                    >
                      <i className='fa fa-question text-danger'></i>
                    </span>
                  </div>
                  <textarea
                    className='form-control form-control-solid mt-3'
                    rows={5}
                    onChange={(e) => {
                      // setComments(e.target.value)
                      if (onCommentChange) {
                        onCommentChange(e.target.value || '')
                      }
                    }}
                  />
                </div>
                <div>
                  <div className='fw-bolder text-dark'>{'Points de vigilance '}</div>
                  <div className='mt-3'>{vigilent?.TextValue}</div>
                </div>
              </div>
              <div className='d-flex justify-content-center mt-5 pt-5 '>
                <div>
                  <Button
                    disabled={updating}
                    variant={'secondary'}
                    onClick={() => {
                      if(setSubmitting) {
                        setSubmitting(false)
                      }
                    }}
                  >
                    {intl.formatMessage({id: 'CANCEL'})}
                  </Button>
                </div>
                <div style={{width: 30}}></div>
                <div>
                  <Button variant={'primary'} onClick={updateProposal} disabled={updating}>
                    {!updating && 'Je soumets la proposition '}
                    {updating && ' ... '}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default NPTab5Form
